<template>
    <ion-page>
        <ion-header :translucent="true">
            <ion-toolbar>
                <ion-buttons slot="start">
                    <!-- <ion-menu-button color="primary"></ion-menu-button> -->
                    <router-link :to="this.$router.options.history.state.back ? this.$router.options.history.state.back : '/my-ship-pricing-log'" class="ion-padding">
                        <ion-icon :ios="chevronBackOutline" :md="chevronBack"></ion-icon>
                    </router-link>
                </ion-buttons>
                <ion-title>My Ship Pricing Logs</ion-title>
            </ion-toolbar>
        </ion-header>

        <ion-content :fullscreen="true">


            <div id="container">
                <DataTable :loading="loading" editMode="cell" dataKey="serial" :metaKeySelection="false"
                    class="p-datatable-sm" showGridlines :value="logs" :lazy="true" :paginator="false" :rows="totalRow"
                    :totalRecords="totalRow" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                    responsiveLayout="scroll" :rowClass="data=>{ return 'dataRow'}" :stripedRows="true">
                    <template #loading>
                        Loading data, please wait...
                    </template>
                    <template #empty>
                        No records found
                    </template>
                    <!-- <Column selectionMode="multiple" headerStyle="width: 3em">
                    </Column> -->
                    <Column field="Sl" header="#"></Column>
                    <Column field="kam" header="KAM"></Column>
                    <Column field="" header="Price" style="min-width:90px;">
                        <template #body="{data}">
                            <strong>D:</strong> <span v-html="data.device_price"></span><br>
                            <strong>I:</strong> <span v-html="data.installation_charge"></span><br>
                            <strong>So:</strong> <span v-html="data.solar_panel_price"></span><br>
                            <strong>S:</strong> <span v-html="data.monthly_subscription_fee"></span><br>
                        </template>
                    </Column>
                    <Column field="status" header="Status"></Column>
                    <Column field="" header="Approval status" style="min-width:250px;">
                    <template #body="{data}" >
                        <div v-if="jsonDecode(data.approvalStatus)">
                        <span>1st Approval(KAM)({{jsonDecode(data.approvalStatus).first_approver.name}}): <b>{{jsonDecode(data.approvalStatus).first_approval}}</b></span><br>
                        <span>2nd Approval(KAM)({{jsonDecode(data.approvalStatus).second_approver.name}}): <b>{{jsonDecode(data.approvalStatus).second_approval}}</b></span><br>
                        <span>Final Approval(KAM)({{jsonDecode(data.approvalStatus).final_approver.name}}): <b>{{jsonDecode(data.approvalStatus).final_approval}}</b></span>
                        </div>
                        </template>
                    </Column>
                    <Column field="" header="Confirmed By" style="min-width: 120px;">
                        <template #body="{data}">
                            <strong v-html="data.confirmed_by"></strong> <br>
                            <span v-html="data.confirmed_at"></span>
                        </template>
                    </Column>
                    <Column field="confirmedBy" header="Confirmed By" style="min-width: 120px;"></Column>
                    <Column field="confirmed_at" header="Confirmed At" style="min-width: 120px;"></Column>
                    <Column field="createdBy" header="Created By" style="min-width: 120px;"></Column>
                    <Column field="created_at" header="Created At" style="min-width: 120px;"></Column>
                    <Column field="updated_at" header="Updated At" style="min-width: 120px;"></Column>
                    <!-- <Column field="" header="Action">
                        <template #body="{data}">
                            <div v-if="data.status == 'Pending'">
                                <ion-button v-if="data.kam_id == data.ship_kam_id" color="success" fill="outline" @click="updateStatus('Approved', data.id)">Approve</ion-button>
                                <ion-button color="danger" fill="outline"  @click="updateStatus('Cancel', data.id)">Cancel</ion-button>
                            </div>
                            <div v-else class="ion-text-center">-</div>
                        </template>
                    </Column> -->
                </DataTable>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
    import {
        IonButtons,
        IonButton,
        IonContent,
        IonHeader,
        IonMenuButton,
        IonIcon,
        IonPage,
        IonTitle,
        IonToolbar,
        alertController,

    } from '@ionic/vue';
    import {
        defineComponent
    } from 'vue';
    import DataTable from 'primevue/datatable';
    import Column from 'primevue/column';
    import Dropdown from 'primevue/dropdown';
    import Accordion from 'primevue/accordion';
    import AccordionTab from 'primevue/accordiontab';
    import {
        ellipsisVertical,
        ellipsisVerticalOutline,
        chevronBack,
        chevronBackOutline,
    } from "ionicons/icons";

    export default defineComponent({
        name: 'My Device',
        components: {
            IonButtons,
            // IonButton,
            IonContent,
            IonHeader,
            // IonMenuButton,
            IonIcon,
            IonPage,
            IonTitle,
            IonToolbar,
            DataTable,
            Column,
            // Dropdown,
        },
        data() {
            return {
                logs: [],
                loading: false,
                shipData: {
                    companyName: null,
                    clientName: null,
                    shipName: null,
                },
                totalRow:0,
                ellipsisVertical,
                ellipsisVerticalOutline,
                chevronBackOutline,
                chevronBack,
            }
        },
        created(){
            this.loadLog();
        },
        
        methods: {
            loadLog(){
                const data = {
                    'username': window.localStorage.username,
                    'password': window.localStorage.password,
                    'ship_id': this.$route.params.shipId,
                };
                this.$http.post('MyShipPricingLog/SingleShipLog',data).then(response => {
                    console.log(response);
                    const ship = response.data.ship;
                    const logs = [];
                    let Sl = 0;
                    for(const log of response.data.logs){
                        const tempData = JSON.parse(log.data);
                        Sl++;
                        logs.push({
                            'Sl': Sl,
                            'id':log.id,
                            'ship_id':log.ship_id,
                            'device_price':tempData['device_price'] ? parseInt(tempData['device_price']): 0,
                            'solar_panel_price':tempData['solar_panel_price']? parseInt(tempData['solar_panel_price']): 0,
                            'installation_charge':tempData['installation_charge']? parseInt(tempData['installation_charge']): 0,
                            'monthly_subscription_fee':tempData['monthly_subscription_fee']? parseInt(tempData['monthly_subscription_fee']): 0,
                            'kam':log.kam.name,
                            'kam_id':log.kam_id,
                            'ship_kam_id':ship.client.company? ship.client.company.kam_id: null,
                            'status':log.status,
                            'approvalStatus':log.approval_status,
                            'confirmedBy':log.confirmed_by?log.confirmed_by.name : '-',
                            'confirmed_at':log.confirmed_by?this.dateFormate(log.confirmed_at,'d-M-Y h:i:s A'):'',
                            'createdBy':log.created_by.name,
                            'created_at':this.dateFormate(log.created_at,'d-M-Y h:i:s A'),
                            'updated_at':this.dateFormate(log.updated_at,'d-M-Y h:i:s A')
                        });
                    }
                    this.logs = logs;
                });
            },
            updateStatus (status,id){
                if(confirm('Are you sure to '+status+' this log?') && (status == 'Approved' || status == 'Cancel')){
                    console.log(status,id);
                    const data = {
                        'username': window.localStorage.username,
                        'password': window.localStorage.password,
                        'ship_id': this.$route.params.shipId,
                        'status':status,
                        'id':id
                    };
                    this.$http.post('MyShipPricingLog/SingleShipLogUpdate',data).then(response => {
                        if(response.data.status){
                            this.loadLog();
                        }
                    });
                }
            },
            async presentResponseAlert(type, message) {
                const alert = await alertController
                    .create({
                        header: type + '!',
                        // subHeader: 'Subtitle',
                        message: message,
                        buttons: ['OK'],
                    });
                await alert.present();

            },

            dateFormate(data, formate) {
                if (!data) {
                    return '-';
                }
                const monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct',
                    'Nov', 'Dec'
                ];
                const date = new Date(data);
                let newDate = '';
                const dateFormate = formate.split('');
                for (const field of dateFormate) {
                    if (field == 'd') {
                        if (date.getDate() < 10) {
                            newDate += '0' + date.getDate();
                        } else {
                            newDate += date.getDate();
                        }
                    } else if (field == 'm') {
                        const month = date.getMonth() + 1;
                        if (month < 10) {
                            newDate += '0' + month;
                        } else {
                            newDate += month;
                        }
                    } else if (field == 'M') {
                        newDate += monthsShort[date.getMonth()];
                    } else if (field == 'y') {
                        newDate += date.getFullYear().toString().substr(2);
                    } else if (field == 'Y') {
                        newDate += date.getFullYear();
                    } else if (field == 'H') {
                        if ((date.getHours()) < 10) {
                            newDate += '0' + date.getHours();
                        } else {
                            newDate += date.getHours();
                        }
                    } else if (field == 'h') {
                        let hours = date.getHours();
                        if (date.getHours() > 12) {
                            hours = hours - 12;
                        }
                        if (date.getHours() == 0) {
                            hours = 12;
                        }

                        if (hours < 10) {
                            newDate += '0' + hours;
                        } else {
                            newDate += hours;
                        }
                    } else if (field == 'i') {
                        if (date.getMinutes() < 10) {
                            newDate += '0' + date.getMinutes();
                        } else {
                            newDate += date.getMinutes();
                        }
                    } else if (field == 's') {
                        if (date.getSeconds() < 10) {
                            newDate += '0' + date.getSeconds();
                        } else {
                            newDate += date.getSeconds();
                        }
                    } else if (field == 'A' || field == 'a') {
                        if (date.getHours() > 11) {
                            newDate += field == 'A' ? 'PM' : 'pm';
                        } else {
                            newDate += field == 'A' ? 'AM' : 'am';
                        }
                    } else {
                        newDate += field;
                    }
                }
                return newDate;
            },
            jsonDecode(e) {
                if (e) {
                    const data = JSON.parse(e);
                    return data;
                } else {
                    return false;
                }
            },
            async presentAlert(message) {
                const alert = await alertController
                    .create({
                        header: 'Alert!',
                        // subHeader: 'Subtitle',
                        message: message,
                        buttons: ['OK'],
                    });
                await alert.present();

            },
        },

    });
</script>

<style>
    /* .dataRow:nth-child(even){
    background-color: #f2f2f2 !important;
} */
</style>